import React from 'react';

const TeamForm = ({
  show,
  formData,
  setFormData,
  editingTeam,
  organizations,
  coaches,
  availableDivisions,
  isSuperAdmin,
  loading,
  onSubmit,
  onCancel,
  styles,
}) => {
  if (!show) return null;

  return (
    <div style={styles.formContainer}>
      <h3 style={styles.formTitle}>{editingTeam ? 'Edit Team' : 'Create Team'}</h3>
      <form onSubmit={onSubmit}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Organization *</label>
          <select
            style={styles.select}
            value={formData.organization_id}
            onChange={(e) =>
              setFormData({ ...formData, organization_id: e.target.value, coach_id: '' })
            }
            disabled={!isSuperAdmin}
            required
          >
            <option value="">Select organization</option>
            {organizations.map((org) => (
              <option key={org.id} value={org.id}>
                {org.name}
              </option>
            ))}
          </select>
          {!isSuperAdmin && (
            <small style={{ fontSize: '12px', color: '#666' }}>
              Teams must belong to your organization
            </small>
          )}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Team Name *</label>
          <input
            type="text"
            style={styles.input}
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            required
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Division</label>
          <select
            style={styles.select}
            value={formData.division}
            onChange={(e) => setFormData({ ...formData, division: e.target.value })}
          >
            <option value="">Select division</option>
            {availableDivisions.map((division) => (
              <option key={division} value={division}>
                {division}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Season</label>
          <input
            type="text"
            style={styles.input}
            value={formData.season}
            onChange={(e) => setFormData({ ...formData, season: e.target.value })}
            placeholder="e.g., Spring 2025"
          />
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Assign Head Coach</label>
          <select
            style={styles.select}
            value={formData.coach_id}
            onChange={(e) => setFormData({ ...formData, coach_id: e.target.value })}
          >
            <option value="">No coach assigned</option>
            {coaches.map((coach) => (
              <option key={coach.id} value={coach.id}>
                {coach.full_name} ({coach.email})
              </option>
            ))}
          </select>
        </div>

        <div style={styles.formActions}>
          <button
            type="button"
            style={{ ...styles.button, ...styles.secondaryButton }}
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            type="submit"
            style={{ ...styles.button, ...styles.primaryButton }}
            disabled={loading}
          >
            {loading ? 'Saving...' : editingTeam ? 'Update Team' : 'Create Team'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default TeamForm;
